import { useState, useEffect } from "react";
import oc_art from './object-lists/oc-art';
import images from '../images'


function OcArt() {
    // console.log("In OC ART");

    const [ocArt, setOcArt] = useState(
        {
            link: "marketchipping.xyz",
            img: 'Loading...',
            oc_name: "Loading...",
            artist: "Loading...",
            artist_link: 'marketchipping.xyz',

        }
    );
    // console.log("before useEffect ocArt:", ocArt);

    useEffect(() => {
        // console.log("array", oc_art);
        let randomIndex = Math.floor(Math.random()*(oc_art.length));
        if (randomIndex == 0) {
          randomIndex = 1;
        }
        // console.log("randomIndex:", randomIndex);
        let art = oc_art[randomIndex];
        // console.log("art:", art);
        setOcArt(art);
        // console.log("in useEffect ocArt:", ocArt);
    }, []);


//    console.log("END OC ART");


  return (
     <div id="oc-wrapper" className="status-wrapper">

              <div className="status-title"><p>⊹ random oc</p></div>

                  <div className = "oc-display">
                    <img href={ocArt.link} src={ocArt.img}></img>
                    <div className = "oc-info">
                      <p><a href={ocArt.link} target="_blank" rel="noopener noreferrer">{ocArt.oc_name}</a></p>
                      <p>art by: <a href={ocArt.artist_link} target="_blank" rel="noopener noreferrer">{ocArt.artist}</a></p>

                    </div>
                  </div>
                  
                  <img className="deco" id="oc-deco" src={images.velvetmoth_roses.url}></img>
            </div>
  );
}

export default OcArt;